import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';

const EngagementChart = ({ data }) => {
  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload?.length) {
      return (
        <div className="bg-card border border-border rounded-lg p-3 shadow-lg">
          <p className="text-sm font-medium text-foreground mb-2">{payload?.[0]?.payload?.day}</p>
          <div className="space-y-1">
            <p className="text-xs text-foreground">
              <span className="font-medium">Escaneos:</span> {payload?.[0]?.value}
            </p>
            <p className="text-xs text-foreground">
              <span className="font-medium">Visitas:</span> {payload?.[1]?.value}
            </p>
          </div>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-card rounded-lg border border-border shadow-card p-6">
      <div className="mb-6">
        <h3 className="text-lg font-semibold text-foreground">Actividad Semanal</h3>
        <p className="text-sm text-muted-foreground mt-1">
          Escaneos y visitas de los últimos 7 días
        </p>
      </div>

      <div className="w-full h-80" aria-label="Gráfico de actividad semanal">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
            <XAxis 
              dataKey="day" 
              stroke="var(--color-muted-foreground)"
              style={{ fontSize: '12px' }}
            />
            <YAxis 
              stroke="var(--color-muted-foreground)"
              style={{ fontSize: '12px' }}
            />
            <Tooltip content={<CustomTooltip />} />
            <Legend 
              wrapperStyle={{ fontSize: '12px' }}
              iconType="circle"
            />
            <Bar 
              dataKey="scans" 
              fill="var(--color-primary)" 
              radius={[8, 8, 0, 0]}
              name="Escaneos"
            />
            <Bar 
              dataKey="visits" 
              fill="var(--color-secondary)" 
              radius={[8, 8, 0, 0]}
              name="Visitas"
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default EngagementChart;